import linkifyHtml from 'linkify-html'

const linkified = {
  mounted(el: HTMLElement, binding: { value?: object }) {
    el.innerHTML = linkifyHtml(el.innerHTML, binding.value || {})
  },
  updated(el: HTMLElement, binding: { value?: object }) {
    el.innerHTML = linkifyHtml(el.innerHTML, binding.value || {})
  }
}

export default linkified
